// src/components/ModuleSections.tsx
// Модули + подразделы (красивый дизайн + синхронизация)
import React, { useState } from 'react';
import { ChevronDown, ChevronRight, Check, Layers, Zap } from 'lucide-react';

interface Props {
  permissions: any;
  allowedSections: string[];
  onPermissionChange: (key: string, value: boolean) => void;
  onSectionChange: (path: string, value: boolean) => void;
  onBulkChange: (paths: string[], value: boolean) => void;
  onReplaceAll?: (paths: string[]) => void;
}

const MODULES = [
  {
    id: 'hrm', label: 'HRM', subtitle: 'Подбор и сотрудники', icon: '🏢', color: '#2575fc', gradient: 'linear-gradient(135deg, #2575fc, #1e40af)',
    mainKey: 'canViewHRM',
    sections: [
      { id: '/app/hr', label: 'Дашборд', icon: '📈' },
      { id: '/app/hr/employees', label: 'Сотрудники', icon: '👥' },
      { id: '/app/hr/companies', label: 'Клиенты', icon: '🏢' },
      { id: '/app/hr/requisitions', label: 'Заявки на подбор', icon: '📝' },
      { id: '/app/hr/vacancies', label: 'Вакансии', icon: '💼' },
      { id: '/app/hr/candidates', label: 'Кандидаты', icon: '👤' },
      { id: '/app/hr/kanban', label: 'Движение', icon: '🔄' },
      { id: '/app/hr/talent-pool', label: 'Кадровый резерв', icon: '💎' },
      { id: '/app/hr/calendar', label: 'Календарь отпусков', icon: '📅' },
      { id: '/app/hr/checklist-templates', label: 'Чек-листы', icon: '📋' },
      { id: '/app/hr/checklist-analytics', label: 'Аналитика чек-листов', icon: '📊' },
      { id: '/app/hr/mass-funnel', label: 'Воронка масс-подбора', icon: '🎯' },
      { id: '/app/hr/mass-mailings', label: 'Массовые рассылки', icon: '📨' },
      { id: '/app/hr/onboarding', label: 'Доходимость кандидатов', icon: '👥' },
      { id: '/app/hr/recruiters-kpi', label: 'KPI рекрутеров', icon: '🏆' },
      { id: '/app/hr/source-analytics', label: 'Аналитика источников', icon: '📈' },
      { id: '__data_driven__', label: 'Data-Driven', icon: '📊', specialKey: 'canViewDataDriven' },
    ],
  },
  {
    id: 'hr-docs', label: 'КДП', subtitle: 'Кадровое делопроизводство', icon: '📁', color: '#f39c12', gradient: 'linear-gradient(135deg, #f39c12, #d97706)',
    mainKey: 'canViewHRDocuments',
    sections: [
      { id: '/app/hr-docs', label: 'Дашборд', icon: '📈' },
      { id: '/app/hr-docs/documents', label: 'Документы', icon: '📄' },
      { id: '/app/hr-docs/employees', label: 'Сотрудники', icon: '👥' },
      { id: '/app/hr-docs/vacations', label: 'Отпуска', icon: '🏖️' },
      { id: '/app/hr-docs/schedule', label: 'Табель учёта', icon: '⏱️' },
      { id: '/app/hr-docs/acquaintances', label: 'Ознакомления', icon: '📋' },
      { id: '/app/hr-docs/requests', label: 'Запросы справок', icon: '📄' },
      { id: '/app/hr-docs/bulk-sign', label: 'Массовая подпись', icon: '✍️' },
      { id: '/app/hr-docs/labor-safety', label: 'Охрана труда', icon: '🦺' },
      { id: '/app/hr-docs/processes', label: 'Кадровые процессы', icon: '🔄' },
      { id: '/app/hr-docs/employment-books', label: 'Эл. трудовые', icon: '📖' },
      { id: '/app/hr-docs/my-hr', label: 'Мой профиль', icon: '👤' },
      { id: '/app/hr-docs/salaries', label: 'Зарплаты', icon: '💰' },
      { id: '/app/hr-docs/templates', label: 'Шаблоны', icon: '📝' },
      { id: '/app/hr-docs/onboarding', label: 'Онбординг', icon: '🎯' },
      { id: '/app/hr-docs/orders', label: 'Приказы', icon: '📜' },
      { id: '/app/hr-docs/reports', label: 'Отчёты', icon: '📊' },
      { id: '/app/hr-docs/calendar', label: 'Календарь', icon: '📅' },
      { id: '/app/hr-docs/certificates', label: 'ЭЦП', icon: '🔐' },
      { id: '/app/hr-docs/settings', label: 'Настройки', icon: '⚙️' },
    ],
  },
  {
    id: 'sales', label: 'СРМ Продажи', subtitle: 'Сделки и воронки', icon: '💼', color: '#6a11cb', gradient: 'linear-gradient(135deg, #6a11cb, #4c1d95)',
    mainKey: 'canViewSalesCRM',
    sections: [
      { id: '/app/sales', label: 'Дашборд', icon: '📈' },
      { id: '/app/sales/deals', label: 'Сделки', icon: '💼' },
      { id: '/app/sales/tasks', label: 'Задачи', icon: '✅' },
      { id: '/app/sales/approvals', label: 'Согласования', icon: '🎯' },
      { id: '/app/sales/processes', label: 'Процессы', icon: '⚙️' },
      { id: '/app/sales/boards', label: 'Канбаны', icon: '📋' },
      { id: '/app/sales/automation', label: 'Автоматизация', icon: '🤖' },
      { id: '/app/sales/lead-forms', label: 'Лид-формы', icon: '📥' },
      { id: '/app/sales/email-settings', label: 'Почта', icon: '📧' },
      { id: '/app/sales/email-templates', label: 'Шаблоны писем', icon: '📝' },
      { id: '/app/sales/email-sequences', label: 'Цепочки писем', icon: '🔄' },
      { id: '/app/sales/gamification', label: 'Рейтинг', icon: '🏆' },
      { id: '/app/sales/clients', label: 'Клиенты', icon: '👥' },
      { id: '/app/sales/reports', label: 'Отчёты', icon: '📊' },
      { id: '/app/sales/gantt', label: 'Диаграмма Ганта', icon: '📊' },
      { id: '/app/sales/settings', label: 'Настройки', icon: '⚙️' },
    ],
  },
  {
    id: 'elearning', label: 'Обучение', subtitle: 'Курсы, тесты, программы', icon: '🎓', color: '#f97316', gradient: 'linear-gradient(135deg, #f97316, #ea580c)',
    mainKey: 'canViewElearning',
    sections: [
      { id: '/app/elearning', label: 'Главная', icon: '🏠' },
      { id: '/app/elearning/tests', label: 'Тесты', icon: '📝' },
      { id: '/app/elearning/calendar', label: 'Календарь', icon: '📅' },
      { id: '/app/elearning/constructor', label: 'Конструктор', icon: '⚙️' },
      { id: '/app/elearning/paths', label: 'Программы', icon: '🛣️' },
      { id: '/app/elearning/task-benefits', label: 'Задачи', icon: '📊' },
      { id: '/app/elearning/benefits', label: 'Бенефиты', icon: '🎁' },
      { id: '/app/elearning/achievements', label: 'Достижения', icon: '🏆' },
      { id: '/app/elearning/analytics', label: 'Аналитика', icon: '📈' },
      { id: '/app/elearning/comparative', label: 'Сравн. аналитика', icon: '📉' },
      { id: '/app/elearning/hr-dashboard', label: 'HR Дашборд', icon: '📊' },
      { id: '/app/elearning/profile', label: 'Мой профиль', icon: '👤' },
      { id: '/app/elearning/rating', label: 'Рейтинг', icon: '🏅' },
      { id: '/app/elearning/my-assignments', label: 'Мои назначения', icon: '📋' },
      { id: '/app/elearning/audit', label: 'Журнал аудита', icon: '🛡️' },
      { id: '/app/elearning/kpi', label: 'KPI', icon: '🎯' },
      { id: '/app/elearning/comments', label: 'Комментарии', icon: '💬' },
    ],
  },
  {
    id: 'accounting', label: 'Бухгалтерия', subtitle: 'Финансы и налоги', icon: '💰', color: '#10b981', gradient: 'linear-gradient(135deg, #10b981, #047857)',
    mainKey: 'canViewAccountingCRM',
    sections: [
      { id: '/app/accounting', label: 'Дашборд', icon: '📈' },
      { id: '/app/accounting/requests', label: 'Заявки', icon: '📨' },
      { id: '/app/accounting/invoices', label: 'Счета', icon: '🧾' },
      { id: '/app/accounting/payments', label: 'Платежи', icon: '💳' },
      { id: '/app/accounting/calendar', label: 'Календарь', icon: '📅' },
      { id: '/app/accounting/counterparties', label: 'Контрагенты', icon: '🏢' },
      { id: '/app/accounting/operations', label: 'Операции', icon: '📝' },
      { id: '/app/accounting/accounts', label: 'План счетов', icon: '📚' },
      { id: '/app/accounting/documents', label: 'Документы', icon: '📄' },
      { id: '/app/accounting/tax', label: 'Налоги', icon: '📊' },
      { id: '/app/accounting/reports', label: 'Отчёты', icon: '📈' },
      { id: '/app/accounting/bank', label: 'Банк', icon: '🏦' },
      { id: '/app/accounting/settings', label: 'Настройки', icon: '⚙️' },
    ],
  },
];

const ModuleSections: React.FC<Props> = ({ permissions, allowedSections, onPermissionChange, onSectionChange, onBulkChange, onReplaceAll }) => {
  const perms = permissions || {};
  const allowed = Array.isArray(allowedSections) ? allowedSections : [];
  const [expanded, setExpanded] = useState<Record<string, boolean>>({ hrm: false, 'hr-docs': false, sales: false, accounting: false });

  const toggleExpand = (id: string) => setExpanded(e => ({ ...e, [id]: !e[id] }));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 12, width: '100%' }}>
      {MODULES.map(m => {
        const enabled = !!perms[m.mainKey];
        const allAllowed = allowed.length === 0;
        const checkedCount = allAllowed
          ? m.sections.filter(s => !(s as any).specialKey).length
          : m.sections.filter(s => allowed.includes(s.id)).length;
        const allChecked = checkedCount === m.sections.length;
        const noneChecked = checkedCount === 0;
        const isExpanded = expanded[m.id];

        const selectAll = () => {
          const paths = m.sections.map(s => s.id);
          onBulkChange(paths, true);
          if (!enabled) onPermissionChange(m.mainKey, true);
        };
        const clearAll = () => {
          const paths = m.sections.map(s => s.id);
          onBulkChange(paths, false);
        };

        return (
          <div key={m.id} style={{
            borderRadius: 14, overflow: 'hidden',
            background: '#fff',
            border: enabled ? `1.5px solid ${m.color}40` : '1px solid rgba(0,0,0,0.08)',
            boxShadow: enabled ? `0 4px 16px -4px ${m.color}30` : '0 1px 3px rgba(0,0,0,0.04)',
            transition: 'all 0.2s',
          }}>
            {/* Header модуля */}
            <div style={{
              padding: '12px 14px',
              background: enabled ? `${m.color}08` : 'transparent',
              display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
            }}>
              {/* Иконка + toggle */}
              <div
                onClick={() => onPermissionChange(m.mainKey, !enabled)}
                style={{
                  width: 44, height: 44, borderRadius: 12, flexShrink: 0,
                  background: enabled ? m.gradient : 'rgba(0,0,0,0.05)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 22, cursor: 'pointer',
                  boxShadow: enabled ? `0 4px 12px -2px ${m.color}66` : 'none',
                  transition: 'all 0.2s',
                  position: 'relative',
                }}
              >
                {m.icon}
                {enabled && (
                  <div style={{
                    position: 'absolute', bottom: -3, right: -3,
                    width: 18, height: 18, borderRadius: '50%',
                    background: '#10b981', border: '2px solid #fff',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  }}>
                    <Check size={10} color="#fff" strokeWidth={3} />
                  </div>
                )}
              </div>

              {/* Название */}
              <div style={{ flex: 1, minWidth: 140 }}>
                <div style={{ fontSize: 14, fontWeight: 800, color: '#1a1a2e', display: 'flex', alignItems: 'center', gap: 6 }}>
                  {m.label}
                  {enabled && checkedCount > 0 && (
                    <span style={{
                      fontSize: 10, padding: '1px 7px', borderRadius: 8,
                      background: `${m.color}15`, color: m.color, fontWeight: 800,
                    }}>
                      {checkedCount}/{m.sections.length}
                    </span>
                  )}
                  {enabled && noneChecked && (
                    <span style={{
                      fontSize: 10, padding: '1px 7px', borderRadius: 8,
                      background: 'rgba(16,185,129,0.12)', color: '#10b981', fontWeight: 800,
                    }}>
                      всё
                    </span>
                  )}
                </div>
                <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 1 }}>{m.subtitle}</div>
              </div>

              {/* Кнопки управления */}
              {enabled && (
                <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                  <button onClick={selectAll} disabled={allChecked} style={btnMicro(m.color, allChecked)}>
                    <Check size={10} /> Все
                  </button>
                  <button onClick={clearAll} disabled={noneChecked} style={btnMicro('#94a3b8', noneChecked)}>
                    Снять
                  </button>
                  <button onClick={() => toggleExpand(m.id)} style={{
                    background: 'rgba(0,0,0,0.04)', border: 'none', borderRadius: 6,
                    padding: 6, cursor: 'pointer', display: 'flex', alignItems: 'center',
                  }}>
                    {isExpanded ? <ChevronDown size={14} color="#64748b" /> : <ChevronRight size={14} color="#64748b" />}
                  </button>
                </div>
              )}
            </div>

            {/* Подразделы */}
            {enabled && isExpanded && (
              <div style={{
                padding: '10px 14px 14px',
                borderTop: '1px solid rgba(0,0,0,0.05)',
                background: 'rgba(248,250,252,0.6)',
              }}>
                {allowed.length === 0 && enabled && (
                  <div style={{
                    padding: '6px 10px', marginBottom: 8, borderRadius: 8,
                    background: 'rgba(16,185,129,0.06)', border: '1px solid rgba(16,185,129,0.15)',
                    fontSize: 11, color: '#10b981', display: 'flex', alignItems: 'center', gap: 6,
                  }}>
                    <Zap size={12} /> Все разделы разрешены (сними галочку чтобы ограничить)
                  </div>
                )}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 6 }}>
                  {m.sections.map(s => {
                    const isSpecial = !!(s as any).specialKey;
                    // ★ ПУСТОЙ allowed = ВСЕ РАЗДЕЛЫ РАЗРЕШЕНЫ (синхронизация с Layout)
                    const allAllowed = allowed.length === 0;
                    const checked = isSpecial
                      ? !!perms[(s as any).specialKey]
                      : (allAllowed || allowed.includes(s.id));
                    const handleClick = () => {
                      if (isSpecial) {
                        onPermissionChange((s as any).specialKey, !checked);
                        return;
                      }

                      // Список всех разделов (без special)
                      const allSectionIds: string[] = [];
                      MODULES.forEach(mod => {
                        mod.sections.forEach(sec => {
                          if (!(sec as any).specialKey) allSectionIds.push(sec.id);
                        });
                      });

                      if (allAllowed && onReplaceAll) {
                        // Сейчас "все разрешены" → отключаем ОДИН
                        // Сохраняем список ВСЕХ минус текущий
                        onReplaceAll(allSectionIds.filter(id => id !== s.id));
                      } else {
                        // Обычный toggle
                        onSectionChange(s.id, !checked);
                      }
                    };
                    return (
                      <div
                        key={s.id}
                        onClick={handleClick}
                        style={{
                          padding: '8px 10px', borderRadius: 10, cursor: 'pointer',
                          display: 'flex', alignItems: 'center', gap: 8,
                          background: checked ? `${m.color}12` : '#fff',
                          border: checked ? `1.5px solid ${m.color}50` : '1px solid rgba(0,0,0,0.06)',
                          transition: 'all 0.15s',
                          userSelect: 'none',
                        }}
                      >
                        <div style={{
                          width: 16, height: 16, borderRadius: 5, flexShrink: 0,
                          border: checked ? `2px solid ${m.color}` : '2px solid #cbd5e1',
                          background: checked ? m.color : '#fff',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                          {checked && <Check size={10} color="#fff" strokeWidth={3} />}
                        </div>
                        <span style={{ fontSize: 14, lineHeight: 1 }}>{s.icon}</span>
                        <span style={{
                          fontSize: 12, fontWeight: checked ? 700 : 500,
                          color: checked ? '#1a1a2e' : '#475569',
                          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                        }}>
                          {s.label}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Кнопка развернуть если не enabled */}
            {enabled && !isExpanded && (
              <div
                onClick={() => toggleExpand(m.id)}
                style={{
                  padding: '8px 14px', textAlign: 'center', cursor: 'pointer',
                  fontSize: 11, color: '#64748b', fontWeight: 600,
                  borderTop: '1px solid rgba(0,0,0,0.04)',
                  background: 'rgba(0,0,0,0.01)',
                }}
              >
                {checkedCount === 0 ? 'Открыть список подразделов' : `Показать ${checkedCount} выбранных`} ▾
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

const btnMicro = (color: string, disabled: boolean): React.CSSProperties => ({
  padding: '4px 10px', border: 'none', borderRadius: 6,
  background: disabled ? 'rgba(0,0,0,0.04)' : `${color}15`,
  color: disabled ? '#cbd5e1' : color,
  cursor: disabled ? 'not-allowed' : 'pointer',
  fontSize: 10, fontWeight: 700, fontFamily: 'inherit',
  display: 'inline-flex', alignItems: 'center', gap: 3,
});

export default ModuleSections;
